export default {
  title: 'Use of Cookies',
  info: 'This website uses cookies to ensure you get the best experience on our website.',
  view: 'View Cookies Policy',
};
